import React from "react";
import { Outlet } from "react-router-dom";
import MarketingNavbar from "./MarketingNavbar";
import Footer from "../Common/Footer";
import "./Marketing.css";

export default function MarketingLayout() {
  return (
    <div className="mk-shell">
      <MarketingNavbar />
      <main className="mk-main">
        <Outlet />
      </main>
      <Footer variant="landing" />
    </div>
  );
}
